import * as yup from 'yup';

export const addPaymentTransaccionSchema = yup.object({
  forma_pago: yup.string().required('La forma de pago es requerida'),
  total_pagado: yup
    .number()
    .typeError('El total pagado es requerido')
    .required('El total pagado es requerido'),
  comision: yup
    .number()
    .typeError('La comisión es requerida')
    .required('La comisión es requerida')
    .test(
      'not-bigger-than-total',
      'La comisión no puede ser mayor al total pagado',
      function (value) {
        return value <= this.parent.total_pagado;
      }
    ),
  rubro: yup.string().required('El rubro es requerido'),
  observacion: yup.string().optional(),
});

export const addSaldoSchema = yup.object({
  rubro_origen: yup
    .number()
    .typeError('Ingrese un rubro válido')
    .required('El rubro origen es requerido'),
  // rubro_destino: yup
  //   .number()
  //   .typeError('Ingrese un rubro válido')
  //   .required('El rubro destino es requerido'),
  monto: yup
    .number()
    .typeError('El monto debe ser un número')
    .required('El monto es requerido'),

  descripcion: yup.string().optional(),
});
